import React, { Component } from 'react'
import Collapsible from 'react-collapsible'
import { FormBuilderObjects } from '../variables/formBuilderData'
import FieldsList from './FieldsList'
import StagesManager from './StagesManager'
import FieldsData from './FieldsData'
import { translate } from '../utils/useful'
import moment, { Moment } from 'jalali-moment'

export default class ActivityLogs extends Component {
    state = {

        backbtn: false,
        notification: [
            { icon: '/assets/images/calln.svg', title: "{lang}}Connection", Date: "14 November 2022", description: "Suspendisse vitae sapien nulla justo." },
            { icon: '/assets/images/mailn.svg', title: "{lang}}Applets", Date: "14 November 2022", description: "Suspendisse vitae sapien nulla justo." },
            { icon: '/assets/images/videon.svg', title: "{lang}}Public Posts", Date: "14 November 2022", description: "Suspendisse vitae sapien nulla justo." },
            { icon: '/assets/images/messagen.svg', title: "{lang}}Expertise", Date: "14 November 2022", description: "Suspendisse vitae sapien nulla justo." }
        ],
        tabs: [
            { title: 'All', key: 'all' },
            { title: 'Stages', key: 'stages' },
        ],
        currentTab: 'all',
        recordLogs: [],
    }
    componentDidMount() {
        this.setState({ recordLogs: this.props.recordLogs })
    }
    changeTab = (key) => {
        if (key != this.state.currentTab) {
            let recordLogs
            // console.log('changeTab', key)
            if (key == 'all') {
                recordLogs = this.props.recordLogs
            }
            else {
                console.log('this.props.recordLogs', this.props.recordLogs)
                recordLogs = this.props.recordLogs.filter((e) => e?.field == 'stage')
            }
            this.setState({ currentTab: key, recordLogs })
        }
    }
    showData = (data) => {
        // console.log('dataooss', data)
        Object.entries(data?.values)?.map(([key, value]) => {
            this.props.headers.map((element) => {
                if (key == element.id) {
                    console.log('vlas', value)
                }
            })
        })
    }
    BackStage = () => {
        this.stageManager.lastStage()
        this.setState({ backbtn: false })

    }

    render() {
        return (
            <div className=' scroll-no-scrollbar h-100 white-bg'>
                <div className='flexc p-3 position-sticky top-0 w-100' style={{ background: 'linear-gradient(90deg, #5856D6, #7D7AFF)', zIndex: 2, height: '50px' }}>
                    {this.state.backbtn == true &&
                        <button onClick={this.BackStage}>
                            <img width={18} className='mrd-2 flexcc' src='/assets/icons/arrow-left-white.svg' />
                        </button>
                    }
                    <p className='white font-size-14'>{translate('Show Activity Logs')}</p>
                </div>
                <div>
                    <div>
                        {console.log('this.props.recordLogs', this.props.recordLogs)}
                        <div className='flexc px-2' style={{ backgroundColor: '#f6f6f6' }} >
                            {this.state.tabs.map((element) => {
                                return (
                                    <div onClick={() => this.changeTab(element.key)} className={'px-4 flexcc py-2 ' + (this.state.currentTab == element.key ? "activity-tab" : "")} style={{ cursor: 'pointer', }}>
                                        <p className='text-small'>{element.title}</p>
                                    </div>
                                )
                            })}
                        </div>
                        <div className='p-2'>
                            {console.log(this.state.recordLogs, 'this.state.recordLogs')}
                            {console.log('this.props.headers', this.props.headers)}
                            {this.state.recordLogs.map((item, index) => {
                                let image
                                let bgColor
                                if (item.activity == 'create') {
                                    image = '/assets/icons/add-log.svg'
                                    bgColor = '#34c759'
                                }
                                if (item.activity == 'update') {
                                    image = '/assets/icons/update-log.svg'
                                    bgColor = '#007aff'
                                }
                                if (item.activity == 'delete') {
                                    image = '/assets/icons/delete-log.svg'
                                    bgColor = '#ff3b30'
                                }
                                return (
                                    <div className="d-flex flexc w-100">
                                        <div className="d-flex flexc cursor-pointer connect-selection px-3 w-100 br-10">
                                            <div className="">
                                                <div style={{ borderRight: "1px dashed #C3C3C3", width: "1px", height: "30px", margin: "auto", marginTop: '2px' }}></div>
                                                <div className="flexcc" style={{ background: bgColor, borderRadius: '50%' }}>
                                                    <img className="br-50" style={{ objectFit: "cover", width: "40px", height: "40px", }} src={image} />
                                                </div>
                                                <div style={{ borderRight: "1px dashed #C3C3C3", width: "1px", height: "30px", margin: "auto" }}></div>
                                            </div>
                                            <div className="mld-4">
                                                <div className="d-flex flex-column">
                                                    <div className="flexc">
                                                        <p className="font-size-14 weight-900">{item.activity}</p>
                                                    </div>
                                                    <div className="flexc">
                                                        {/* {item.field == 'data' ? (
                                                            <>
                                                                {this.showData(item.data)}
                                                            </>
                                                        ) : ''}
                                                        {item.field == 'stage' ? (
                                                            <></>
                                                        ) : ''} */}
                                                        {/* <p className="font-size-12">{item.message}</p> */}
                                                    </div>
                                                    <div className="flexc pt-1">
                                                        <p className="font-size-12">{moment(item.cDate).locale('en').format('YYYY-MMMM-DD ')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
